import React from 'react';
import Footer from '../components/Footer';
import RankingHome from '../components/ranking/RankingHome';

import { useEffect } from 'react';

const HomePage = () => {
  useEffect(() => {
    const htmlEl = document.documentElement;
    const bodyEl = document.body;

    const previous = {
      htmlOverflow: htmlEl.style.overflow,
      bodyOverflow: bodyEl.style.overflow,
      htmlHeight: htmlEl.style.height,
      bodyHeight: bodyEl.style.height,
    };

    // Solo bloquear el scroll en pantallas grandes (desktop/tablet en horizontal),
    // donde hay altura de sobra. En móvil/tablet estrecho se permite el scroll
    // natural para que el contenido nunca quede recortado bajo el footer fijo.
    const mql = window.matchMedia('(min-width: 1024px)');

    const restore = () => {
      htmlEl.style.overflow = previous.htmlOverflow;
      bodyEl.style.overflow = previous.bodyOverflow;
      htmlEl.style.height = previous.htmlHeight;
      bodyEl.style.height = previous.bodyHeight;
    };

    const applyScrollLock = () => {
      if (mql.matches) {
        window.scrollTo(0, 0);
        htmlEl.style.overflow = 'hidden';
        bodyEl.style.overflow = 'hidden';
        htmlEl.style.height = '100dvh';
        bodyEl.style.height = '100dvh';
      } else {
        restore();
      }
    };

    applyScrollLock();
    mql.addEventListener('change', applyScrollLock);

    return () => {
      mql.removeEventListener('change', applyScrollLock);
      restore();
    };
  }, []);
  return (
    <>
      <section className="relative min-h-[calc(100dvh-4rem)] lg:overflow-hidden px-4 py-6 pb-32 lg:pb-6">
        <div className="relative z-10 w-full max-w-6xl lg:max-w-5xl xl:max-w-4xl mx-auto overflow-hidden">
          <RankingHome />
        </div>
      </section>
      <Footer fixed />
    </>
  );
};

export default HomePage;
